import { render, staticRenderFns } from "./UnreadBubble.vue?vue&type=template&id=51f2cf1e&scoped=true&"
import script from "./UnreadBubble.vue?vue&type=script&lang=js&"
export * from "./UnreadBubble.vue?vue&type=script&lang=js&"
import style0 from "./UnreadBubble.vue?vue&type=style&index=0&id=51f2cf1e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f2cf1e",
  null
  
)

export default component.exports